module.exports = __webpack_public_path__ + "img/step4.1312eaf4.png";